import { Box, Tabs, Tab, Grid, Button, TextField, makeStyles, Theme, createStyles } from "@mui/material";
import { FC, useState } from "react";
import TabPanel from "../../components/Tabpanel/Tabpanel";
import CloseIcon from "@mui/icons-material/Close";
import { SubmitHandler, useForm, Controller, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

function a11yProps(index: string) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

interface IFormInputs {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
}

const schema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().min(4, "ta doido?").max(20).required("ta doido?"),
    firstName: yup.string().required(),
    lastName: yup.string().required("escreve isso vacilão")
});

const TestField = () => {
    const methods = useForm<IFormInputs>({
        resolver: yupResolver(schema)
    });

    const formSubmitHandler: SubmitHandler<IFormInputs> = (data: IFormInputs) => {
        console.log('form data is', data);
    }

    return (
        <div style={{ marginTop: '50px' }}>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(formSubmitHandler)}>
                    <SubComponent />
                    <br />
                    <br />
                    <SubComponentTwo />
                    <br />
                    <input type="submit" value="Submit" />
                </form>
            </FormProvider>
        </div>
    )
}

const SubComponent : FC = () => {
    const { control, formState: { errors } } = useFormContext();

    return (
        <div>
            <Controller 
                name="email" 
                control={control} 
                defaultValue="example@davi.test.com"
                render={({ field }) => (
                    <TextField {...field} label="Email" variant="outlined"  type="email"
                        error={!!errors.email}
                        helperText={errors?.email ? errors.email?.message : '' } 
                    />
                )}
            />
            <br />
            <br />
            <Controller 
                name="password"
                control={control}
                defaultValue=""
                render={({ field }) => (
                    <TextField {...field} label="Password" variant="outlined" type="password"
                        error={!!errors.password}
                        helperText={errors?.password ? errors.password?.message : '' } />
                )}
            />
            <br />
        </div>
    );
};

const SubComponentTwo : FC = () => {
    const { control, formState: { errors } } = useFormContext();

    return (
        <div>
            <Controller 
                name="firstName" 
                control={control} 
                defaultValue="Davi"
                render={({ field }) => (
                    <TextField {...field} label="First name" variant="outlined"  type="text"
                        error={!!errors.firstName}
                        helperText={errors?.firstName ? errors.firstName?.firstName : '' } 
                    />
                )}
            />
            <br />
            <br />
            <Controller 
                name="lastName"
                defaultValue=""
                control={control}
                render={({ field }) => (
                    <TextField {...field} label="Last name" variant="outlined"
                        error={!!errors.lastName}
                        helperText={errors?.lastName ? errors.lastName?.message : '' } />
                )}
            />
        </div>
    );
};


// const Static = () => {
//     const [value, setValue] = useState(0);

//     const handleChange = (event, newValue) => {
//       setValue(newValue);
//     };


//     return (
//         <Box sx={{ width: '1000px', height: '100%', typography: 'body1' }}>
//             <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//                 <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
//                     <Tab label="Static" {...a11yProps(0)} />
//                     <Tab label="DYNAMIC" {...a11yProps(1)} />
//                     <Tab label="Closable" {...a11yProps(2)} />
//                 </Tabs>
//             </Box>
//             <TabPanel value={value} index={0}>
//                 Static
//             </TabPanel>
//             <TabPanel value={value} index={1}>
//                 <Dynamic />
//             </TabPanel>
//             <TabPanel value={value} index={2}>
//                 <Closable />
//             </TabPanel>
//       </Box>
//     )
// }

// const Dynamic = () => {
//     const [value, setValue] = useState(0);

//     const [tabs, setTabs] = useState([]);
//     const [panels, setPanels] = useState([]);
//     const [tabIndex, setTabIndex] = useState(1);

//     const handleChange = (event, newValue) => {
//         setValue(newValue);
//       };

//     const createNewTab = () => {
//         const newTab = {
//             value: `${tabIndex}`,
//             label: `Dynamic teste ${tabIndex}`
//         };

//         const newPanel = {
//             value: `${tabIndex}`,
//             child: () => <div>Panel number º {tabIndex}</div>
//         }

//         setTabs([...tabs, newTab]);
//         setPanels([... panels, newPanel]);
//         handleChange(null, `${tabIndex}`);
//         setTabIndex(tabIndex + 1);
//     }

//     return (
//         <Box sx={{ width: '100%', height: '100%', typography: 'body1' }}>
//             <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//                 <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
//                     <Tab label="create new tab" {...a11yProps(0)} />
//                     { tabs.map((tab) => (
//                         <Tab label={tab.label} value={tab.value} key={tab.value} {...a11yProps(tab.value)} />
//                     )) }
//                 </Tabs>
//             </Box>
//             <TabPanel value={value} index={0}>
//                 <Button onClick={createNewTab} >create</Button>
//             </TabPanel>
//             { panels.map((panel) => (
//                 <TabPanel index={panel.value} value={value} key={panel.value}>
//                     {panel.child()}
//                 </TabPanel>
//             )) }
//       </Box>
//     )
// }

// const Closable = () => {
//     const [value, setValue] = useState(0);

//     const [tabs, setTabs] = useState([]);
//     const [panels, setPanels] = useState([]);
//     const [tabIndex, setTabIndex] = useState(1);

//     const handleChange = (event, newValue) => {
//         setValue(newValue);
//       };

//     const createBlue = () => {
//         const newTab = {
//             value: `${tabIndex}`,
//             label: `Blue box ${tabIndex}`
//         };

//         const newPanel = {
//             value: `${tabIndex}`,
//             child: () => <div style={{ height: '300px', width: '300px', backgroundColor: "blue" }} />
//         }

//         setTabs([...tabs, newTab]);
//         setPanels([... panels, newPanel]);
//         handleChange(null, `${tabIndex}`);
//         setTabIndex(tabIndex + 1);
//     }


//     const createRed = () => {
//         const newTab = {
//             value: `${tabIndex}`,
//             label: `Red box ${tabIndex}`
//         };

//         const newPanel = {
//             value: `${tabIndex}`,
//             child: () => <div style={{ height: '300px', width: '300px', backgroundColor: "red" }} />
//         }

//         setTabs([...tabs, newTab]);
//         setPanels([... panels, newPanel]);
//         handleChange(null, `${tabIndex}`);
//         setTabIndex(tabIndex + 1);
//     }

//     const handleTabClose = (closedValue) => {
//         const tabArray = tabs.filter(tab => tab.value !== closedValue );
//         const panel = panels.filter(panel => panel.value !== closedValue);

//         setTabs(tabArray);
//         setPanels(panel);

//         if (value !== 0) {
//             handleChange(null, 0);
//         }
//     }

//     return (
//         <Box sx={{ width: '100%', height: '100%', typography: 'body1' }}>
//             <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//                 <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
//                     <Tab label="new closable tab" {...a11yProps(0)} />
//                     { tabs.map((tab) => (
//                         <Tab 
//                             icon={<CloseIcon onClick={() => handleTabClose(tab.value)} />} 
//                             iconPosition="end" 
//                             label={tab.label} 
//                             value={tab.value} 
//                             key={tab.value} {...a11yProps(tab.value)} />
//                     )) }
//                 </Tabs>
//             </Box>
//             <TabPanel value={value} index={0}>
//                 <Grid container spacing={2} >
//                     <Grid item xs={12} md={6}>
//                         <Button variant="contained" color="primary" onClick={createBlue} >Create blue box</Button>
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                         <Button variant="contained" color="secondary" onClick={createRed} >Create red box</Button>
//                     </Grid>
//                 </Grid>
//             </TabPanel>
//             { panels.map((panel) => (
//                 <TabPanel index={panel.value} value={value} key={panel.value}>
//                     {panel.child()}
//                 </TabPanel>
//             )) }
//       </Box>
//     )
// }


export { TestField }